module.exports = __webpack_public_path__ + "img/mg.bc0aaf02.svg";